import React, { useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';


function FullCalendarReact() {
    const [events, setEvents] = useState([
        { title: 'Học ReactJS', start: '2025-10-17' },
        { title: 'Họp nhóm', start: '2025-10-18T14:00:00', end: '2025-10-18T16:00:00' }
    ]);

    // Khi người dùng click vào ngày
    const handleDateClick = (info) => {
        const title = prompt('Nhập tên sự kiện:');
        if (title) {
            setEvents([...events, { title, start: info.dateStr }]);
        }
    };

    // Khi click vào event
    const handleEventClick = (info) => {
        alert(`Sự kiện: ${info.event.title}`);
    };

    return (
        <div className="container mt-4">
            <h2 className="mb-3">Lịch sự kiện</h2>

            <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth" // giao diện mặc định: tháng
                editable={true} // cho phép kéo thả
                selectable={true} // cho phép chọn vùng trống
                events={events}
                dateClick={handleDateClick}
                eventClick={handleEventClick}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }}
                height="100vh"
            />
        </div>
    );
}

export default FullCalendarReact;
